import React from "react";

import { UserMadFullFragment } from "../../graphql/fragments";

import useTranslations from "../../hooks/useTranslations";
import { Link } from "../wombat-ui";
import Avatar from "../wombat-ui/Avatar";

type CollaboratorHeaderProps = {
  user: UserMadFullFragment;
};

const CollaboratorHeader: React.FC<CollaboratorHeaderProps> = ({ user }) => {
  const t = useTranslations();

  return (
    <div className="bg-light-0">
      <div className="max-w-6xl px-4 py-5 mx-auto sm:flex md:items-center md:justify-between sm:px-6 lg:px-24">
        <div className="flex items-center justify-between flex-grow">
          <div className="flex items-center justify-start space-x-4">
            <span className="relative">
              <Avatar
                src={user.avatar}
                alt="user avatar"
                size={24}
                type="user"
              />
            </span>
            <div>
              <h2 className="text-xl font-bold leading-8 text-primary-800 sm:text-2xl sm:leading-9 sm:truncate">
                {user.name}
              </h2>
              <div className="max-w-xl text-base text-dark-300 sm:text-lg sm:truncate sm:max-w-2xl">
                <a
                  className="text-sm text-primary-500"
                  href={`mailto:${user.email}`}
                >
                  {user.email}
                </a>
                <p className="text-xs">
                  {t("collaborator.registeredOn", {
                    date: new Date(user.createdAt).toLocaleDateString(),
                  })}
                </p>
              </div>
            </div>
          </div>
          {user.canInsert && (
            <Link
              to={`/users/${user.slug}/edit`}
              variant="button"
            >
              {t("forms.actions.edit")}
            </Link>
          )}
        </div>
      </div>
    </div>
  );
};

export default CollaboratorHeader;
